import compose from "./compose";
/**
 * It applies middleware, if any are passed, and creates
 * the dispatcher of the Redhooks store.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function}
 */

export default (function () {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (store) {
    var _dispatch = function dispatch() {
      throw new Error("Dispatcher not ready yet!");
    };

    var middlwareAPI = {
      getState: store.getState,
      dispatch: function dispatch() {
        return _dispatch.apply(void 0, arguments);
      }
    };
    var chain = middlewares.map(function (middleware) {
      return middleware(middlwareAPI);
    });
    _dispatch = compose.apply(void 0, chain)(store.dispatch);
    return _dispatch;
  };
});